import { put } from 'redux-saga/effects';
import { ApiCaller, Utils } from '../../config';
import { ShiftDropOrSwap } from '../actions';

export default class ShiftDropOrSwapMiddleware {
    static *GetShiftDropOrSwap(params) {
        const { payload } = params;
        console.log('my pay', payload?.formattedStatus);
        try {
            let res = yield ApiCaller.Get(
                `/drop-requests?perPage=${payload?.limit}&page=${payload?.page}&search=${payload?.search}&${payload?.formattedStatus}`,
            );
            if (res?.data?.status == 200) {
                yield put(ShiftDropOrSwap.GetDropOrSwapSuccess(res?.data));
            }
        } catch (error) {
            yield put(ShiftDropOrSwap.GetDropOrSwapFailure(Utils.isSubscriptionError(error)));
            Utils.showMessage('error', error?.response?.data?.message);
        }
    }

    static *GetDSRDetail(params) {
        const { payload, cb } = params;
        console.log(payload);
        try {
            let res = yield ApiCaller.Get(`/drop-request/${payload}`);
            if (res?.data?.status == 200) {
                Utils.showMessage('success', res?.data?.message);
                yield put(
                    ShiftDropOrSwap.GetDropOrSwapDetailSuccess(res?.data?.data),
                );
            }
        } catch (error) {
            yield put(ShiftDropOrSwap.GetDropOrSwapDetailFailure());
            Utils.showMessage('error', error?.response?.data?.message);
        }
    }
}
